import { render, staticRenderFns } from "./amap.vue?vue&type=template&id=5bcd06cc&scoped=true"
import script from "./amap.vue?vue&type=script&lang=js"
export * from "./amap.vue?vue&type=script&lang=js"
import style0 from "./amap.vue?vue&type=style&index=0&id=5bcd06cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd06cc",
  null
  
)

/* custom blocks */
import block0 from "./amap.vue?vue&type=custom&index=0&blockType=div&class=forms_title"
if (typeof block0 === 'function') block0(component)
import block1 from "./amap.vue?vue&type=custom&index=1&blockType=div&class=forms"
if (typeof block1 === 'function') block1(component)

export default component.exports